import * as Sentry from "@sentry/react";
import config from "../../constants/Configs";
Sentry.init({
    dsn: "https://59e1099fbd4211802ed106faaaa95b7c@send.sentry.report//29",
    environment: config.ENV ? config.ENV : 'not-specified',
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.reactRouterV5BrowserTracingIntegration({ history }),
        Sentry.replayIntegration({
            // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
            maskAllText: false,
            blockAllMedia: false,
            maxReplayDuration: 180,// Limit replay duration to 180 seconds (3 minutes)
            // mask: [".mask-me"],
            // unmask: [".unmask-me"],
        })
    ],
    //tracePropagationTargets: ["localhost", "http://localhost:53987"],
    // Performance Monitoring
    tracesSampleRate: 0.3, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 0.2, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});